export const TIME_FORMAT = {
  DATE_TIME_FULL: 'DD/MM/YYYY - hh:mm a',
  DATE_TIME: 'DD/MM/YYYY HH:mm',
  DATE_FORMAT: 'YYYY-MM-DD',
  DATE_TIME_FORMAT_MYSQL: 'YYYY-MM-DD HH:mm:ss',
  API_DATE_TIME: 'MM-DD-YYYY h:mm:ss A',
}

export const ONE_DAY = 24 * 60 * 60 * 1000
export const ONE_SECOND = 1000; // 1 second in milliseconds
export const ONE_MINUTE = 60_000; // 1 minute in milliseconds
export const ONE_HOUR = 60 * ONE_MINUTE; // 1 hour in milliseconds
